import { KernelSize } from 'postprocessing';
import { GodRays } from '@react-three/postprocessing';
import { KERNEL_SIZE } from '@artica/constants';

export default function Rays({ sun, camera }) {
  return (
    <GodRays
      sun={ sun.current }
      camera={ camera.current }
      density={ 0.96 } // The density of the light rays.
      decay={ 0.95 } // An illumination decay factor.
      weight={ 0.15 } // A light ray weight factor.
      exposure={ 0.9 } // A constant attenuation coefficient.
      // blur={ true }
      kernelSize={ KernelSize[KERNEL_SIZE] } // The blur kernel size. Has no effect if blur is disabled.
    />
  );
};